import { render, staticRenderFns } from "./List.vue?vue&type=template&id=00060d60&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=00060d60&prod&lang=scss&scoped=true"
import style1 from "./List.vue?vue&type=style&index=1&id=00060d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00060d60",
  null
  
)

export default component.exports